import { render, staticRenderFns } from "./ActionBox.vue?vue&type=template&id=0dda6cb7&"
import script from "./ActionBox.vue?vue&type=script&lang=js&"
export * from "./ActionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports